import { Pipe, PipeTransform } from '@angular/core';
import {
  PortalFlightItineraryGroupNode,
  PortalServiceClassType,
} from '@app/services/api/api.types';

@Pipe({
  name: 'extractServiceClasses',
  standalone: true,
})
export class ExtractServiceClassesPipe implements PipeTransform {
  transform(flightSegments: PortalFlightItineraryGroupNode[]): PortalServiceClassType[] {
    const serviceClasses: PortalServiceClassType[] = [];

    flightSegments?.forEach((flight) => {
      flight?.segments?.forEach((segment) => {
        const serviceClass = segment?.flightSegment?.serviceClass;
        if (serviceClass) {
          serviceClasses.push(serviceClass);
        }
      });
    });

    return serviceClasses;
  }
}
